import { RouteObject } from "react-router-dom";
import pathRoutes from "../../../routes/pathRoutes";
import Authenticated from "../../../utils/Authenticated";
import DebugIndexPage from "../DebugIndexPage";
import Sr89DebugPage from "../sr89Debug/Sr89DebugPage";
import Sr89ComparePage from "../sr89Debug/Sr89ComparePage";
import Ni63DebugPage from "../ni63Debug/Ni63DebugPage";
import AlfaTotalDebugPage from "../alfaTotalDebug/AlfaTotalDebugPage";
import BetaTotalDebugPage from "../btDebug/BetaTotalDebugPage";
import BetaRestoDebugPage from "../brDebug/BetaRestoDebugPage";

const routesDebug: RouteObject = {
  path: pathRoutes.ADMIN_DEBUG,
  children: [
    {
      index: true,
      element: (
        <Authenticated>
          <DebugIndexPage />
        </Authenticated>
      ),
    },
    {
      path: "sr89",
      element: (
        <Authenticated>
          <Sr89DebugPage />
        </Authenticated>
      ),
    },
    {
      path: "sr89/comparar",
      element: (
        <Authenticated>
          <Sr89ComparePage />
        </Authenticated>
      ),
    },
    {
      path: "ni63",
      element: (
        <Authenticated>
          <Ni63DebugPage />
        </Authenticated>
      ),
    },
    {
      path: "alfa-total",
      element: (
        <Authenticated>
          <AlfaTotalDebugPage />
        </Authenticated>
      ),
    },
    {
      path: "beta-total",
      element: (
        <Authenticated>
          <BetaTotalDebugPage />
        </Authenticated>
      ),
    },
    {
      path: "beta-resto",
      element: (
        <Authenticated>
          <BetaRestoDebugPage />
        </Authenticated>
      ),
    },
  ],
};

export default routesDebug;
